import { CHART_TYPE } from '../constants';
import { IChartSeries, IChartLegend } from '../models';
import { formatNumber } from '../utils/data-format-helper';

const extractLegendValues = (series: IChartSeries[], formatNumbers : boolean): string[] => {
  return series[0]?.data.map(m => `${series[0]?.valuePrefix || ''}${formatNumbers ? formatNumber(m.y) : m.y}${series[0]?.valueSuffix || ''}`);
};

const extractLegendValuesInPercentage = (series: IChartSeries[], legend: IChartLegend): string[] => {
  const data = series[0]?.data || [];

  if (data.length === 0) {
    return [];
  }

  const totalValue = data.reduce((pre, curr) => pre + curr.y, 0);

  return data.map(d => `${(d.y * 100 / totalValue).toFixed(legend.noOfDecimalsInPercentage)}%`);
};

/*----------------- Exports -------------- */

export const getLegendLabels = (chartType: CHART_TYPE, series: IChartSeries[], legend: IChartLegend): string[] => {
  if (!legend || !series || series?.length === 0) {
    return [];
  }

  if (legend.labels?.length) {
    return legend.labels;
  }

  switch (chartType) {
    case CHART_TYPE.PIE:
    case CHART_TYPE.DONUT:
    case CHART_TYPE.SEMI_CIRCLE:
      return series[0]?.data.map(m => m.name);
    case CHART_TYPE.STACKED_BAR:
    default:
      return series.map(m => m.name);
  }
};

export const getLegendLabelValues = (chartType: CHART_TYPE, series: IChartSeries[], legend: IChartLegend, formatNumbers : boolean = false): string[][] => {
  let legendValues = new Array<Array<string>>();

  // legend values observed only in circular chart
  const allowedChartTypes = [
    CHART_TYPE.PIE,
    CHART_TYPE.DONUT,
    CHART_TYPE.SEMI_CIRCLE,
    CHART_TYPE.STACKED_BAR
  ];

  if (!legend || !series || series?.length === 0 || allowedChartTypes.indexOf(chartType) === - 1) {
    return legendValues;
  }

  if (legend.values?.length) {
    legendValues = legend.values;
  } else {
    legendValues.unshift(extractLegendValues(series, formatNumbers));
  }

  if (legend.showDataValueProportion) {
    legendValues.unshift(extractLegendValuesInPercentage(series, legend));
  }

  return legendValues;
};
